// @flow

type Callback = () => mixed;

export default function confirmAction(message: string, success: Callback, failed: Callback = function() {}): Promise<any> {
  var promise = new Promise(function (resolve, reject) {
    if (window.confirm(message)) {
      resolve();
    }
    reject();
  });

  return promise.then(success, failed);
}



// WEBPACK FOOTER //
// ./src/utils/confirm-action.js